import React, { useState, useEffect } from 'react';

export default function LetterConfirmModal({ group, onCancel, onConfirm, locale }) {
  const [theme, setTheme] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!group) return;

    setTheme(
      locale === 'kz'
        ? 'Республикалық ғылыми-практикалық білім мазмұнын сараптау орталығының қорытынды хаты'
        : 'Заключительное письмо Республиканского научно-практического центра экспертизы содержания образования'
    );

    setDescription(
      locale === 'kz'
        ? `Сіздермен әзірленген оқулықтар мен оқу әдістемелік кешендерге сараптама жұмыстарын ұйымдастырып, сараптама қорытындысы бойынша төмендегіні хабарлайды.\nҰсынылған аталымдар Пәндік сараптамалық комиссияның қарауына ұсынылады.\nҚосымша: бет.`
        : `Организована экспертиза учебников и учебно-методических комплексов, разработанных вами. По результатам экспертизы сообщаем следующее:\nПредставленные номинации направлены на рассмотрение Предметной экспертной комиссии.\nПриложение: страниц.`
    );
  }, [group, locale]);

  const handleConfirm = async () => {
    if (!theme || !description) return;
    setLoading(true);
    try {
      await onConfirm(group.id, theme, description);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      onClick={onCancel}
      style={{
        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
        backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex',
        justifyContent: 'center', alignItems: 'center', zIndex: 9999,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#fff', padding: '2rem', borderRadius: '8px',
          maxWidth: '600px', width: '90%', boxShadow: '0 0 10px rgba(0,0,0,0.2)',
          position: 'relative',
        }}
      >
        {/* Жабу */}
        <button
          onClick={onCancel}
          style={{
            position: 'absolute', top: '10px', right: '10px',
            background: 'transparent', border: 'none',
            fontSize: '1.2rem', cursor: 'pointer',
          }}
        >
          ×
        </button>

        <h2 style={{ marginBottom: '1rem' }}>
          {locale === 'kz' ? 'Хатты растау' : 'Подтвердить письмо'}
        </h2>

        <p style={{ color: '#555', marginBottom: '1rem', fontSize: '0.9rem' }}>
          {locale === 'kz'
            ? '📄 Хат жасалғаннан кейін бірден PDF форматта сақталады.'
            : '📄 После создания письмо сразу сохраняется в формате PDF.'}
        </p>

        <div style={{ marginBottom: '1rem' }}>
          <label><strong>{locale === 'kz' ? 'Тақырып' : 'Тема'}:</strong></label>
          <input
            type="text"
            value={theme}
            onChange={(e) => setTheme(e.target.value)}
            style={{
              width: '100%', padding: '0.5rem', marginTop: '0.3rem',
              borderRadius: '4px', border: '1px solid #ccc', boxSizing: 'border-box',
            }}
          />
        </div>

        <div style={{ marginBottom: '1rem' }}>
          <label><strong>{locale === 'kz' ? 'Сипаттамасы' : 'Описание'}:</strong></label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={5}
            style={{
              width: '100%', padding: '0.5rem', marginTop: '0.3rem',
              borderRadius: '4px', border: '1px solid #ccc', boxSizing: 'border-box',
              resize: 'vertical',
            }}
          />
        </div>

        <div style={{ marginTop: '1.5rem', display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
          <button
            onClick={onCancel}
            disabled={loading}
            style={{
              padding: '0.5rem 1.2rem', background: '#ccc',
              border: 'none', borderRadius: '4px', cursor: 'pointer',
            }}
          >
            {locale === 'kz' ? 'Болдырмау' : 'Отмена'}
          </button>

          <button
            onClick={handleConfirm}
            disabled={!theme || !description || loading}
            style={{
              padding: '0.5rem 1.2rem',
              background: (!theme || !description || loading) ? '#aaa' : '#28a745',
              color: '#fff', border: 'none', borderRadius: '4px',
              cursor: (!theme || !description || loading) ? 'not-allowed' : 'pointer',
            }}
          >
            {loading
              ? (locale === 'kz' ? 'Жасалуда...' : 'Создание...')
              : (locale === 'kz' ? '📄 Хат жасау және PDF сақтау' : '📄 Создать письмо и сохранить PDF')}
          </button>
        </div>
      </div>
    </div>
  );
}